import React, { useState } from 'react';
import { X, Layers } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';

export default function ConsolidarModal({ paquetes, onClose, onConsolidado }) {
  const [guiaAgrupada, setGuiaAgrupada] = useState('');
  const [guardando, setGuardando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!guiaAgrupada.trim()) return toast.error('Ingresa la guía agrupada.');

    setGuardando(true);
    try {
      await api.post('/paquetes/consolidar/', {
        paquete_ids: paquetes.map((p) => p.id),
        guia_agrupada: guiaAgrupada.trim(),
      });
      toast.success('Paquetes consolidados.');
      onConsolidado();
    } catch (err) {
      toast.error(mensajeErrorApi(err, 'No se pudo consolidar.'));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Consolidar paquetes</h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>

        <p className="text-secondary text-sm" style={{ marginBottom: 'var(--spacing-4)' }}>
          Se agruparán {paquetes.length} paquetes bajo una sola guía agrupada.
        </p>

        <div style={{ marginBottom: 'var(--spacing-4)', padding: 'var(--spacing-3)', background: 'var(--color-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
          {paquetes.map((p) => (
            <div key={p.id} className="text-sm" style={{ padding: '4px 0' }}>
              <strong>{p.guia || p.tracking}</strong>
              {p.descripcion && <span className="text-secondary"> — {p.descripcion}</span>}
            </div>
          ))}
        </div>

        <form onSubmit={handleSubmit} className="form-stack">
          <div>
            <label>Guía agrupada *</label>
            <input
              value={guiaAgrupada}
              onChange={(e) => setGuiaAgrupada(e.target.value)}
              placeholder="Ej: EC23MTC0050"
              required
              autoFocus
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={guardando}>
              <Layers size={16} /> {guardando ? 'Consolidando...' : 'Consolidar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
